export default __webpack_public_path__ + "602cea81e49adac48b947a4a95249270.svg";